export enum MapVariant {
  Dots = 'dots',
  Clustered = 'clustered',
  Heatmap = 'heatmap',
}

export const DEFAULT_MAP_VARIANT = MapVariant.Dots;

export const isMapVariant = (value?: string): value is MapVariant =>
  Object.values(MapVariant).includes(value as MapVariant);

export const toMapVariant = (value?: string): MapVariant =>
  (isMapVariant(value) ? value : DEFAULT_MAP_VARIANT);
